module.exports = __webpack_public_path__ + "static/media/Adoption.c32fbba0.png";